<script>
import { iBadge, iSpinner, iFeaturedIcon } from '@inscribe/signal';
import StatusBadge, {
  StatusStyles,
} from '@/V2/components/status/StatusBadge.vue';
import { Statuses } from '@/V2/components/status/utils';
import DocumentStatus from '@/V2/documents/document-status/DocumentStatus.vue';
import {
  DOCUMENT_REVIEW_STATUS,
  documentReviewStatusToReadableLabel,
} from '@/constants/documentStatus';

export default {
  name: 'DocumentReviewStatusBadge',
  components: {
    iBadge,
    iSpinner,
    iFeaturedIcon,
    StatusBadge,
  },
  props: {
    reviewStatus: {
      type: String,
      required: true,
      validator: (value) => {
        return Object.values(DOCUMENT_REVIEW_STATUS).includes(value);
      },
    },
    class: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      Statuses,
      StatusStyles,
      DocumentStatus,
      documentReviewStatusToReadableLabel,
    };
  },
  computed: {
    state() {
      switch (this.reviewStatus) {
        case DOCUMENT_REVIEW_STATUS.ACCEPTED:
        case DOCUMENT_REVIEW_STATUS.AUTO_ACCEPTED:
          return Statuses.SUCCESS;
        case DOCUMENT_REVIEW_STATUS.REQUIRES_REVIEW:
          return Statuses.WARNING;
        case DOCUMENT_REVIEW_STATUS.REJECTED:
          return Statuses.ERROR;
        default:
          return Statuses.NEUTRAL;
      }
    },
  },
};
</script>
<template>
  <div :class="class">
    <status-badge
      :type="StatusStyles.OUTLINE"
      :state="state"
      :label="documentReviewStatusToReadableLabel(reviewStatus)"
    />
  </div>
</template>
